import React from 'react';

interface YoutubeSidebarItemProps {
  icon: string;
  label: string;
  active?: boolean;
}

const YoutubeSidebarItem: React.FC<YoutubeSidebarItemProps> = ({ icon, label, active }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 13,
      padding: '8px 0 8px 18px',
      margin: '0 12px',
      borderRadius: 0,
      background: 'none',
      fontFamily: 'Inter, system-ui, sans-serif',
      fontWeight: active ? 600 : 500,
      fontSize: 16,
      cursor: 'pointer',
      transition: 'color 0.15s',
    }}
  >
    <i className={icon} style={{ fontSize: 21, width: 26, textAlign: 'center', color: active ? '#23272f' : '#b0b4c1' }}></i>
    <span style={{ flex: 1, color: active ? '#6366f1' : '#b0b4c1', fontWeight: active ? 600 : 500, textAlign: 'left' }}>{label}</span>
  </div>
);

export default YoutubeSidebarItem;
